import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col, Card } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { publishImage } from "../../helpers/imageupload";
import { getAsset } from "../../helpers/helper";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { ClearIcon } from "@mui/x-date-pickers";
import { images } from "../../constants";
import url from "../../config/axios";

const UpdateExperienceModal = ({ show, handleClose, serviceid, updateid,datareturnfun }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [displayimg, setDisplayimg] = useState([]);

  // Correct API body structure
  const [userdata, setUserData] = useState({
    name: "",
    projectName: "",
    detail: "",
    images: []
  });

  // Fetch old data
  useEffect(() => {
    if (!updateid) return;

    url
      .get(
        `service/GetCertExpeSer/id/?id=${serviceid}&experienceid=${updateid}`
      )
      .then((res) => {
        const d = res?.data?.data?.item;

        setUserData({
          name: d?.name || "",
          projectName: d?.projectName || "",
          detail: d?.detail || "",
          images: d?.images || []
        });

        setDisplayimg(d?.images || []);
      })
      .catch((err) => console.log(err));
  }, [updateid]);

  // Input handler
  const handleChange = (e) => {
    const { name, value } = e.target;

    setUserData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Image upload
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const uploadedImages = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      setUserData((prev) => ({
        ...prev,
        images: uploadedImages
      }));

      setDisplayimg(uploadedImages);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop
  });

  // Remove image
  const removeImage = (index) => {
    const updated = displayimg.filter((_, i) => i !== index);

    setDisplayimg(updated);

    setUserData((prev) => ({
      ...prev,
      images: updated
    }));
  };

  // PATCH API
  const UpdateUserdata = () => {
    url
      .patch(
        `service/updateSingleExperience/id/?id=${serviceid}&experienceid=${updateid}`,
        userdata
      )
      .then((res) => {
        if (res.data.success) {
          datareturnfun('type');
          handleClose();
          SuccessNotify("Experience Updated Successfully");
        }
      })
      .catch(() => {
        FailedNotify("Failed to Update Try Again");
        handleClose();
      });
  };

  return (
    <Modal show={show === 6} onHide={handleClose} centered size="lg">
      <Modal.Header
        className="text-white pt-1 pb-1"
        style={{ backgroundColor: "#0353A4" }}
        closeButton
      >
        <Modal.Title>Update Experience</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            <Col lg="6">
              <Form.Group className="mb-3">
                <Form.Label>Service Name</Form.Label>
                <Form.Select
                  value={userdata?.name}
                  onChange={handleChange}
                  className="p-2 pb-3"
                  name="name"
                >
                  <option value="">Select (logo design etc)</option>
                  <option value="Logo Design">Logo Design</option>
                  <option value="UI/UX">UI/UX</option>
                  <option value="Poster Design">Poster Design</option>
                  <option value="Branding">Branding</option>
                  <option value="Web Design">Web Design</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col lg="6">
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Name / Work Area or Discipline (Optional)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter project name"
                  value={userdata?.projectName}
                  onChange={handleChange}
                  name="projectName"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Description */}
          <Form.Group className="mb-3">
            <Form.Label>Project Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Describe your role and responsibilities"
              value={userdata?.detail}
              onChange={handleChange}
              name="detail"
            />
          </Form.Group>

          {/* Image Upload */}
          <Col>
            <Row>
              <Col lg="9" className="me-auto">
                <Row>
                  <Col lg={3} className="mt-2 ms-1">
                    <Card
                      style={{
                        width: "6rem",
                        height: "6rem",
                        position: "relative"
                      }}
                      {...getRootProps()}
                      className="dropzone"
                    >
                      {isUploading ? (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255,255,255,0.7)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            borderRadius: "0.5rem"
                          }}
                        >
                          <div
                            className="spinner-border text-primary"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          ></div>
                          <small className="mt-1">{uploadProgress}%</small>
                        </div>
                      ) : (
                        <>
                          <Card.Img className="imet-fit" src={images?.AddImage} />
                          <Card.Body>
                            <input
                              type="file"
                              {...getInputProps()}
                              style={{ display: "none" }}
                            />
                          </Card.Body>
                        </>
                      )}
                    </Card>
                  </Col>

                  {displayimg.length > 0 && (
                    <Col lg={7} className="mt-1 d-flex">
                      {displayimg.map((image, index) => (
                        <Card
                          key={index}
                          className="me-2 mt-1"
                          style={{
                            width: "6rem",
                            height: "6rem",
                            border: "2px solid",
                            position: "relative"
                          }}
                        >
                          <Card.Img
                            className="imet-fit upload-img mt-0"
                            src={getAsset(image)}
                            alt=""
                            crossOrigin="anonymous"
                          />
                          <div
                            className="close-btnone"
                            onClick={() => removeImage(index)}
                          >
                            <ClearIcon />
                          </div>
                        </Card>
                      ))}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={handleClose}
          style={{
            backgroundColor: "white",
            border: "1px solid red",
            color: "red"
          }}
        >
          Cancel
        </button>
        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={UpdateUserdata}
          style={{
            backgroundColor: "#0353A4",
            border: "1px solid #0353A4",
            color: "white"
          }}
        >
          Update
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateExperienceModal;
